import { useState, SyntheticEvent, useEffect } from 'react';
import { EducationBackgroundForm } from './components/education-background-form';
import { PostConsultantEducationBackgroundModel } from '../../models';
import { Button, Col, FlexboxGrid, Radio, RadioGroup } from 'rsuite';
import { ValueType } from 'rsuite/esm/Checkbox';
import { handleGetConsultantEducationBackground } from '../../api-handler';
import { useNavigate } from 'react-router-dom';
// import { showToast } from '../../utils/toast';
import { CustomLoader } from './../../components/basic/loader';

export const ConsultantEducationBackground = (props: {
  disabledMode?: boolean;
  isAdmin?: boolean;
  username?: string;
}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [editMode, setEditMode] = useState(false);

  const [data, setData] = useState<(PostConsultantEducationBackgroundModel | null)[]>([]);
  const [isDoing, setIsDoing] = useState<ValueType>('yes');

  const handleAddEducationData = (
    newData: PostConsultantEducationBackgroundModel | null,
    isCurrent: boolean
  ) => {
    console.log('update array', newData, isCurrent);
    if (isCurrent) {
      return setData((prev) => {
        return [newData, ...prev.slice(1, -1)];
      });
    }
    return setData((prev) => {
      return [...prev, newData];
    });
  };

  useEffect(() => {
    (async () => {
      setLoading(true);

      const res = await handleGetConsultantEducationBackground(
        props.isAdmin ? props.username : null
      );
      if (res.ok) {
        if (!res.data[0].StudyNow) {
          setData([null, ...res.data]);
          setIsDoing('no');
        } else {
          setData(res.data);
        }
        console.log(editMode);
        setEditMode(true);
      }
      setLoading(false);
    })();
  }, [props.username]);

  if (loading) {
    return <CustomLoader />;
  }

  return (
    <>
      <h4 className="text-h4">
        {props.isAdmin ? 'سوابق تحصیلی' : 'سوابق تحصیلی خود را وارد کنید'}
      </h4>

      <FlexboxGrid className="mt-8">
        <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={6} lg={5} className="max-w-[100%]">
          <RadioGroup
            value={isDoing}
            dir="rtl"
            // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
            disabled={props.disabledMode || editMode}
            onChange={(value: ValueType, _event: SyntheticEvent<Element, Event>) =>
              setIsDoing(value)
            }>
            <div className="flex items-center">
              <div className="w-[50%]">مشغول به کار</div>
              <Radio className="w-[25%]" value={'yes'}>
                بله
              </Radio>
              <Radio className="w-[25%]" value={'no'}>
                خیر
              </Radio>
            </div>
          </RadioGroup>
        </FlexboxGrid.Item>
      </FlexboxGrid>

      {data.map((item, index) => {
        return isDoing !== 'yes' && index === 0 ? null : (
          <EducationBackgroundForm
            key={`${item?.RandomId}-${index}`}
            handleAddDoingData={handleAddEducationData}
            currentDoing={index === 0}
            readonly={index === 0 && isDoing === 'yes' && item === null ? false : true}
            hideNextButton={index === 0 && isDoing === 'yes' && item === null ? true : false}
            defaultValue={item}
            disabledMode={props.disabledMode}
          />
        );
      })}
      {!editMode && data.length ? (
        <EducationBackgroundForm
          handleAddDoingData={handleAddEducationData}
          currentDoing={false}
          forceReadOnly={loading}
          disabledMode={props.disabledMode}
        />
      ) : !editMode && isDoing === 'yes' ? (
        <EducationBackgroundForm
          handleAddDoingData={handleAddEducationData}
          currentDoing={true}
          forceReadOnly={loading}
          disabledMode={props.disabledMode}
        />
      ) : !editMode && !props.disabledMode ? (
        <Button
          appearance="primary"
          className="ml-auto mt-4"
          type="button"
          onClick={() => handleAddEducationData(null, false)}>
          افزودن سابقه جدید
        </Button>
      ) : null}

      {editMode && !props.disabledMode ? (
        <div className="flex justify-between">
          <Button
            appearance="default"
            className="ml-auto mt-8"
            type="button"
            onClick={() => {
              navigate('/consultant/work');
              // showToast('اطلاعات قبلا ثبت شده', 'warning');
            }}
            loading={loading}>
            مرحله قبل
          </Button>
          <Button
            appearance="primary"
            className="mr-auto mt-8"
            type="button"
            onClick={() => {
              navigate('/consultant/consultation');
              // showToast('اطلاعات قبلا ثبت شده', 'warning');
            }}
            loading={loading}>
            مرحله بعد
          </Button>
        </div>
      ) : null}
    </>
  );
};
